import React, { lazy, Suspense, useEffect, useRef, useState } from "react"

import { window } from "browser-monads"
import { ErrorBoundary } from "react-error-boundary";

import {
  dataStore,
  locationStore,
  pageStore,
} from "state/store-zustand";

import CityLabel from 'components/post/cityLabel'
import Gradient from "components/shared/gradient"
import LazyBackground from "components/elements/background-image"

const BasicMap = lazy(() => import("components/map/basicMap"))
const ShareButtons = lazy(() => import('components/post/shareButtons'))

import * as style_variables from 'vibemap-constants/design-system/build/json/variables.json'
const vibe_styles = style_variables['default']['color']['vibes']
import "./postImpactArea.scss"

const PostImpactArea = ({
  data,
  bannerLayout = 'map',
  bannerLink = null,
  showDate = true,
  type,
  zoom = 12
}) => {

  const isMobile = pageStore((state) => state.isMobile)
  const height = isMobile ? 360 : 420 // TODO: Adjust mobile

  const places = dataStore((state) => state.places)
  const currentCity = locationStore((state) => state.cityCurrent)
  const currentLocation = locationStore((state) => state.locationCurrent)
  const setCityCurrent = locationStore((state) => state.setCityCurrent)
  const setCurrentLocation = locationStore((state) => state.setLocationCurrent)

  const vibesets = data.postDetails.vibeset
  const firstVibeset = vibesets && vibesets[0].slug ? vibesets[0].slug : 'dreamy'

  const [color1, setColor1] = useState(vibe_styles[firstVibeset]['primary'])
  const [color2, setColor2] = useState(vibe_styles[firstVibeset]['secondary'])

  const [mapWidth, setMapWidth] = useState(300)
  const ref = useRef()
  useEffect(() => {
    const width = ref.current && ref.current.offsetWidth
    if (width) setMapWidth(width)
  }, []);

  let explorePage = bannerLink ? bannerLink : "https://vibemap.com/map/?"

  if (data.postDetails.vibeset && data.postDetails.vibeset[0].vibesetDetails) {
    explorePage = bannerLink
      ? bannerLink
      : data.postDetails.vibeset[0].vibesetDetails.exploreLink.replace(
        "https://vibemap.com/map?",
        explorePage
      )
  }

  const bgImage = data?.featuredImage?.node?.mediaItemUrl

  const postDate = new Date(data.date)
  const day = postDate.getDate()
  const year = postDate.getFullYear()
  const month = postDate.toLocaleString('default', { month: 'short' });

  const author = data.author ? data.author.node : null

  const categories = data?.categories?.nodes
    ? data?.categories?.nodes
    : data?.categories || []

  const firstCategory = categories[0]
  const typeName = firstCategory && firstCategory.name
  const isVibeGuide =  typeName == "Vibe Guide"

  const postLocation = data?.postDetails?.location
    ? data?.postDetails?.location
    : data?.postDetails?.city?.length > 0
      ? data.postDetails.city[0]?.cityDetails?.placemarker
      : null

  const latitude = currentLocation?.latitude
  const longitude = currentLocation?.longitude

  useEffect(() => {
    //console.log('isVibeGuide ', isVibeGuide);
    if (!isVibeGuide) {
      //setCityCurrent(city)
      if (postLocation) setCurrentLocation(postLocation, false)
    }

  }, [postLocation])


  const PostInfo = showDate
    ? (
      <span className="post-info">
        {(author || data.postDetails.customAuthor)
          ? `By ${data.postDetails.customAuthor
            ? data.postDetails.authorName
            : author.name
          } on ${month} ${day}, ${year}`
          : `Posted on ${month} ${day}, ${year}`}
      </span>
    )
    : null


  const PostVibes = !data.postDetails.vibeset && data.postDetails.vibes
    ? (
      <div>
        <div className={`vibesets vibes`} damping={1} >
          <ul>
            {data.postDetails.vibes.map(vibe => {
              return (
                <li key={vibe}>
                  <a>{vibe}</a>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
    : null

  const PostMap = bannerLayout == 'map'
    ? (
      <div className="column is-4" ref={ref}>
        <div className="map-container">
          <div className="map">
            <Suspense fallback={<span>...</span>}>
              <ErrorBoundary fallback={null}>
                {data.postDetails.location ? (
                  <BasicMap
                    boundsToMarkers={true}
                    fitPlacesToBounds={false}
                    city={currentCity ? currentCity : data.postDetails.city}
                    latitude={latitude}
                    longitude={longitude}
                    link={explorePage}
                    height={420}
                    width={mapWidth}
                    places={places}
                    loadFromTile={false}
                    locationData={postLocation}
                    zoom={zoom}
                  />
                ) : (
                  <BasicMap
                    boundsToMarkers={true}
                    fitPlacesToBounds={false}
                    city={currentCity ? currentCity : data.postDetails.city}
                    latitude={latitude}
                    longitude={longitude}
                    height={420}
                    width={mapWidth}
                    places={places}
                    link={explorePage}
                    zoom={zoom} />
                )}
              </ErrorBoundary>
            </Suspense>
          </div>
        </div>
      </div>
    )
    : null



  return (
    <div>
      <div className="post-header">
        <div className="post-info-container">
          {categories && categories.length > 0 &&
            <span className="post-category">
              <CityLabel city={currentCity} prefix={typeName}/>
            </span>
          }

          <h1 className="post-title">
            {data.title}
          </h1>

          {PostInfo}
          <Suspense fallback={<div>Loading</div>}>
            <ShareButtons
              className="mobile-share-buttons"
              url={window.location.href}
            />
          </Suspense>

        </div>
        <div className={`impact-area ${bannerLayout}`}>
          <div className="container">
            <div className="featured-image">

              {data.featuredImage && (
                <>
                  <LazyBackground className="bg-image" src={bgImage} />

                  {data?.featuredImage?.node?.caption && (
                    <div
                      className="img-caption"
                      dangerouslySetInnerHTML={{
                        __html: data.featuredImage.node.caption
                      }}
                    ></div>
                  )}
                </>
              )}
            </div>
            <div className="columns is-gapless is-flex-tablet">
              <div className={`column ${bannerLayout == 'map' ? 'is-8-desktop' : 'is-12-desktop' } is-8-tablet image`} >
                <div className="featured-image-mobile">
                  {data.featuredImage &&
                    <>
                      <LazyBackground className="bg-image" src={bgImage} />
                      {data?.featuredImage?.node?.caption && (
                        <div
                          className="img-caption"
                          dangerouslySetInnerHTML={{
                            __html: data.featuredImage.node.caption
                          }}
                        ></div>
                      )}
                    </>
                  }
                </div>
                <div className='swiper-container'>
                  <div className="background">
                    <Gradient
                      color1={color1}
                      color2={color2}
                    />
                  </div>
                </div>


                {/* If vibes are overwritten */}
                {PostVibes}

              </div>
              {PostMap}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default PostImpactArea
